export const environment = {
    production: false,
    apiUrl: 'https://api-tctsystems-dev.azurewebsites.net/api',
    version: '1.0.2',
    postApiAddress: 'http://192.168.1.40:3000/jobs?sync=true'
}; 